// Unique code to get top level Page Component and Page SCSS
// The only thing different is the from part should match your component

// All boilerplate cut/paste stuff
/* eslint-disable-next-line  import/newline-after-import */
/* eslint-disable-next-line   import/first */
import ReactDOM from 'react-dom/client';
import React from 'react';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';
import PAGE_COMPONENT from './SingleContentPage';

const checkPageProps = () => {
    let props = {};
    // eslint-disable-next-line no-undef
    if (typeof globalPageProps !== 'undefined') props = globalPageProps;
    if (props.PAGE_PROPS) {
        ReactDOM.hydrateRoot(
            document.getElementById('root'),
            <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
                <PAGE_COMPONENT {...props} />
            </PAGE_CONTEXT>
        );
    } else {
        setTimeout(() => {
            checkPageProps();
        }, 100);
    }
};
checkPageProps();

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'Community/SingleContentPage/SingleContentPage,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

*/
